import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { COMPANY } from "../data/content";

export default function Impressum() {
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <main data-testid="impressum-page" className="bg-[#F5F2ED] min-h-screen pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <Link to="/" data-testid="impressum-back-link" className="inline-flex items-center gap-2 text-sm font-semibold text-[#B5651D] hover:text-[#9c5517] transition-colors mb-8">
          <ArrowLeft size={16} /> Zurück zur Startseite
        </Link>
        <h1 className="font-heading font-bold text-4xl sm:text-5xl tracking-tight text-[#1F2933]">Impressum</h1>

        <div className="mt-10 space-y-8 text-[#22282E] leading-relaxed">
          <section>
            <h2 className="font-heading font-semibold text-lg text-[#1F2933] mb-2">Angaben gemäß § 5 DDG</h2>
            <p>
              {COMPANY.name}<br />
              Inhaber: {COMPANY.owner}<br />
              {COMPANY.ownerTitle}<br />
              {COMPANY.street}<br />
              {COMPANY.city}
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-lg text-[#1F2933] mb-2">Kontakt</h2>
            <p>
              Telefon: {COMPANY.phone}<br />
              Fax: {COMPANY.fax}<br />
              E-Mail: <a href={`mailto:${COMPANY.email}`} className="text-[#B5651D] underline">{COMPANY.email}</a>
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-lg text-[#1F2933] mb-2">Umsatzsteuer-Identifikationsnummer</h2>
            <p>USt-IdNr. gemäß § 27a Umsatzsteuergesetz: {COMPANY.vatId}</p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-lg text-[#1F2933] mb-2">Berufsbezeichnung und Kammer</h2>
            <p>
              Berufsbezeichnung: Fliesen-, Platten- und Mosaikleger (Meisterbetrieb)<br />
              Eingetragen in der {COMPANY.register}.<br />
              Zuständige Kammer: Handwerkskammer Hamburg, Holstenwall 12, 20355 Hamburg
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-lg text-[#1F2933] mb-2">Verantwortlich für den Inhalt gemäß § 18 Abs. 2 MStV</h2>
            <p>
              {COMPANY.owner}<br />
              {COMPANY.street}, {COMPANY.city}
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-lg text-[#1F2933] mb-2">Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte
              auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
              §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht
              verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
              überwachen oder nach Umständen zu forschen, die auf eine
              rechtswidrige Tätigkeit hinweisen.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-lg text-[#1F2933] mb-2">Haftung für Links</h2>
            <p>
              Unser Angebot enthält ggf. Links zu externen Websites Dritter, auf
              deren Inhalte wir keinen Einfluss haben. Für die Inhalte der
              verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
              der Seiten verantwortlich.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-lg text-[#1F2933] mb-2">Urheberrecht</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
              diesen Seiten unterliegen dem deutschen Urheberrecht. Die
              Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
              schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>
        </div>
      </div>
    </main>
  );
}
